module.exports = __webpack_public_path__ + "img/دایره1.6a3c7ee5.png";